import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import { UploadCloud, Edit, Trash2, Search, ChevronLeft, ChevronRight, PackagePlus } from 'lucide-react';
import './AdminItem.css';

const API_URL = 'https://api.sohanihandicrafts.com:5010';

const AdminItem = () => {
    const [items, setItems] = useState([]);
    const [categories, setCategories] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
 const [itemDimensions, setItemDimensions] = useState(''); // NEW
    const [itemWeight, setItemWeight] = useState('');         // NEW
    const [itemMaterial, setItemMaterial] = useState('');     // NEW
    // Form State
    const [itemName, setItemName] = useState('');
    const [itemSku, setItemSku] = useState('');
    const [selectedCategory, setSelectedCategory] = useState('');
    const [itemImage, setItemImage] = useState(null);
    const [imagePreview, setImagePreview] = useState(null);

    const fileInputRef = useRef(null);

    // Pagination
    const [currentPage, setCurrentPage] = useState(1);
    const [totalItems, setTotalItems] = useState(0);
    const itemsPerPage = 8;

    const fetchCategories = async () => {
        try {
            const res = await axios.get(`${API_URL}/api/category/categories?limit=100`);
            setCategories(res.data.categories);
        } catch (err) { console.error(err); }
    };

    const fetchItems = async () => {
        setIsLoading(true);
        try {
            const res = await axios.get(`${API_URL}/api/item/all`, {
                params: { page: currentPage, limit: itemsPerPage }
            });
            setItems(res.data.items);
            setTotalItems(res.data.totalItems);
        } catch (err) { console.error(err); }
        finally { setIsLoading(false); }
    };

    useEffect(() => {
        fetchCategories();
        fetchItems();
    }, [currentPage]);

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setItemImage(file);
            setImagePreview(URL.createObjectURL(file));
        }
    };

     const handleSubmit = async (e) => {
        e.preventDefault();
        // Validation
        if (!itemName || !itemSku || !selectedCategory || !itemDimensions || !itemWeight || !itemMaterial) {
            return Swal.fire('Warning', 'Please fill all text fields', 'warning');
        }

        const formData = new FormData();
        formData.append('name', itemName);
        formData.append('sku', itemSku);
        formData.append('category', selectedCategory);
        formData.append('dimensions', itemDimensions); // NEW
        formData.append('weight', itemWeight);         // NEW
        formData.append('material', itemMaterial);     // NEW
        formData.append('itemImage', itemImage);

        try {
            await axios.post(`${API_URL}/api/item/add`, formData);
            Swal.fire('Success', 'Piece added to catalog', 'success');
            // Reset all fields
            setItemName(''); setItemSku(''); setItemDimensions(''); 
            setItemWeight(''); setItemMaterial(''); setSelectedCategory('');
            setItemImage(null); setImagePreview(null);
            fetchItems();
        } catch (err) {
            Swal.fire('Error', err.response?.data?.msg || 'Failed to add item', 'error');
        }
    };

    const handleDelete = (id) => {
        Swal.fire({
            title: 'Remove Item?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, Delete'
        }).then(async (result) => {
            if (result.isConfirmed) {
                await axios.delete(`${API_URL}/api/item/delete/${id}`);
                fetchItems();
            }
        });
    };

    return (
        <div className="adm-itm-wrapper">
            <div className="adm-itm-header">
                <h1>Product Catalog</h1>
                <p>Add and manage individual handicraft pieces</p>
            </div>

            {/* --- ADD SECTION --- */}
            <div className="adm-itm-card add-card">
                <div className="adm-itm-card-head">
                    <PackagePlus size={20} color="#C5A059" />
                    <h3>Add New Piece</h3>
                </div>
              <div >
                <form onSubmit={handleSubmit} className="adm-itm-form">
                    <div className="form-grid">
                        <div className="form-group">
                            <label>Piece Name</label>
                            <input type="text" value={itemName} onChange={(e) => setItemName(e.target.value)} placeholder="e.g. Factory Iron Rack" />
                        </div>
                        <div className="form-group">
                            <label>SKU Number</label>
                            <input type="text" value={itemSku} onChange={(e) => setItemSku(e.target.value)} placeholder="e.g. CLPW-01" />
                        </div>
                        <div className="form-group">
                            <label>Category</label>
                            <select value={selectedCategory} onChange={(e) => setSelectedCategory(e.target.value)}>
                                <option value="">-- Choose Category --</option>
                                {categories.map(cat => <option key={cat._id} value={cat._id}>{cat.name}</option>)}
                            </select>
                        </div>
                        {/* NEW TEXT BOXES */}
                        <div className="form-group">
                            <label>Dimensions (WxDxH)</label>
                            <input type="text" value={itemDimensions} onChange={(e) => setItemDimensions(e.target.value)} placeholder="e.g. 100 x 38 x 205 cm" />
                        </div>
                        <div className="form-group">
                            <label>Total Weight</label>
                            <input type="text" value={itemWeight} onChange={(e) => setItemWeight(e.target.value)} placeholder="e.g. 59 kg" />
                        </div>
                        <div className="form-group">
                            <label>Primary Material</label>
                            <input type="text" value={itemMaterial} onChange={(e) => setItemMaterial(e.target.value)} placeholder="e.g. Recycled Wood" />
                        </div>
                    </div>
                      <div className="image-upload-row">
                        <div className="file-drop-area" onClick={() => fileInputRef.current.click()}>
                            <input type="file" hidden ref={fileInputRef} onChange={handleFileChange} />
                            {imagePreview ? <img src={imagePreview} alt="prev" /> : 
                            <div className="placeholder"><UploadCloud /> <span>Upload Product Image</span></div>}
                        </div>
                        <button type="submit" className="submit-btn">Publish Item</button>
                    </div>
                </form>
            </div>
            </div>

            {/* --- TABLE SECTION --- */}
            <div className="adm-itm-card table-card">
                <div className="table-tools">
                    <h3>Inventory List ({totalItems})</h3>
                    <div className="search-bar">
                        <Search size={18} />
                        <input type="text" placeholder="Search by name or SKU..." />
                    </div>
                </div>

                <div className="table-container">
                    <table>
                        <thead>
                            <tr>
                                <th>Visual</th>
                                <th>Product Details</th>
                                <th>Category</th>
                                <th>Status</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {items.map((item) => (
                                <tr key={item._id}>
                                    <td><img src={`${API_URL}/${item.image}`} className="tbl-img" alt="itm" /></td>
                                    <td>
                                        <span className="tbl-name">{item.name}</span>
                                        <span className="tbl-sku">SKU: {item.sku}</span>
                                    </td>
                                    <td><span className="tbl-cat-tag">{item.category?.name || 'Unset'}</span></td>
                                    <td><span className={`status-dot ${item.status ? 'active' : ''}`}></span> {item.status ? 'Live' : 'Hidden'}</td>
                                    <td>
                                        <div className="action-btns">
                                         
                                            <button className="del" onClick={() => handleDelete(item._id)}><Trash2 size={16}/></button>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                <div className="pagination">
                    <button disabled={currentPage === 1} onClick={() => setCurrentPage(p => p - 1)}><ChevronLeft/></button>
                    <span>Page {currentPage}</span>
                    <button disabled={items.length < itemsPerPage} onClick={() => setCurrentPage(p => p + 1)}><ChevronRight/></button>
                </div>
            </div>
        </div>
    );
};

export default AdminItem;